import { c as _c } from "react/compiler-runtime";
// Flex content slot shared by every `<OgShell>` variant. Mirrors the
// Figma Shell "Slot" frame: flex-grow, inner padding, overflow hidden.

import type { CSSProperties, ReactNode } from 'react';
interface OgShellSlotProps {
  children: ReactNode;
  padding: number;
  /** Figma Slot `items-end` — bottom-anchors children, left via `alignItems`. */
  contentJustify?: 'start' | 'end';
}
export function OgShellSlot(props) {
  const $ = _c(6);
  const t0 = props.contentJustify === "end" ? "flex-end" : "flex-start";
  let t1;
  if ($[0] !== props.padding || $[1] !== t0) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0,
      position: "relative",
      zIndex: 1,
      padding: props.padding,
      overflow: "hidden",
      width: "100%",
      alignItems: "flex-start",
      justifyContent: t0
    };
    $[0] = props.padding;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const slotStyle = t1;
  let t2;
  if ($[3] !== props.children || $[4] !== slotStyle) {
    t2 = <div style={slotStyle}>{props.children}</div>;
    $[3] = props.children;
    $[4] = slotStyle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}

/** Bottom-anchors content inside shells whose slot stays top-aligned (Figma 479:700). */
export function OgShellSlotBottom(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      minHeight: 0,
      flex: 1,
      alignItems: "flex-start",
      justifyContent: "flex-end"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.children) {
    t1 = <div style={t0}>{props.children}</div>;
    $[1] = props.children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}